import * as React from 'react';
export const XKSvg = React.forwardRef(function XKSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M2 2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2Z',
      fill: '#43458B',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M7.3 6.38a1 1 0 0 1 1.4 0l1.92 1.9a1 1 0 0 1 0 1.42L8.7 11.61a1 1 0 0 1-1.42 0l-1.9-1.9a1 1 0 0 1 0-1.42l1.9-1.91Z',
      fill: '#FCD669',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M4.25 5.7a.6.6 0 1 0 0-1.2.6.6 0 0 0 0 1.2Zm1.5-.45a.6.6 0 1 0 0-1.2.6.6 0 0 0 0 1.2Zm1.5-.22a.6.6 0 1 0 0-1.2.6.6 0 0 0 0 1.2Zm1.5 0a.6.6 0 1 0 0-1.2.6.6 0 0 0 0 1.2Zm1.5.22a.6.6 0 1 0 0-1.2.6.6 0 0 0 0 1.2Zm1.5.45a.6.6 0 1 0 0-1.2.6.6 0 0 0 0 1.2Z',
      fill: '#F6F9FC',
    }),
  );
});
XKSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var XK = {
  category: 'flag',
  colorable: false,
  name: 'XK',
  svg: XKSvg,
};
